import { Box, Stack } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import SideMenu from "../components/side-menu.component";
import Header from "../components/header.component";
import AppNavbar from "../components/app-nav-bar.component";
import StickyFooter from "../components/footer.component";
import { MainApiProvider } from "../provider/main-api.provider";
const MainPage = () => {
  const auth = !!localStorage.getItem("TOKEN");

  if (!auth) {
    return <Navigate to="/login" />;
  }
  return (
    <div>
      <MainApiProvider>
        <Box
          sx={{
            display: "flex",
            minHeight: "100vh",
            background: "#f6f8fc",
          }}
        >
          <SideMenu />
          <AppNavbar />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              px: { xs: 1, md: 3 },
              mt: { xs: 9, md: 0 },
            }}
          >
            <Stack
              spacing={2}
              sx={{
                flexGrow: 1,
                alignItems: "center",
              }}
            >
              <Header />
              <Outlet />
            </Stack>
            <Box
              sx={{
                mt: 4,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <StickyFooter />
            </Box>
          </Box>
        </Box>
      </MainApiProvider>
    </div>
  );
};

export default MainPage;
